import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Nationality = "KR" | "JP";
export type Gender = "M" | "F";

export interface SessionUser {
  id: string;
  email: string;
  displayName: string;
  nationality: Nationality;
  gender: Gender;
  isAdult: boolean;
  kycVerified: boolean;
  createdAt: string;
}

interface SessionState {
  user: SessionUser | null;
  onboardingStep: number;
  setUser: (user: SessionUser | null) => void;
  setOnboardingStep: (step: number) => void;
  signOut: () => void;
}

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      user: null,
      onboardingStep: 0,
      setUser: (user) => set({ user }),
      setOnboardingStep: (onboardingStep) => set({ onboardingStep }),
      signOut: () => set({ user: null, onboardingStep: 0 }),
    }),
    { name: "stl-session" },
  ),
);

export function isAuthenticated(state: SessionState): boolean {
  return !!state.user && state.user.isAdult;
}
